import React, { useState, useRef, useEffect } from "react"
import PropTypes from "prop-types"
import loadable from "loadable-components"
import { GiHamburgerMenu } from "react-icons/gi"
import { FiSun, FiMoon } from "react-icons/fi"

import Constants from "utils/constants"
import styles from "./header.module.scss"

const ReactScrollLink = loadable(() =>
  import("react-scroll/modules/components/Link")
)

function Header() {
  const [isSticky, setSticky] = useState(false)
  const [isHidden, setHidden] = useState(true)
  const ref = useRef(null)

  const [theme, setTheme] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("theme") || "dark"
    }
    return "dark"
  })

  useEffect(() => {
    const root = document.documentElement
    if (theme === "light") {
      root.classList.add("light-theme")
    } else {
      root.classList.remove("light-theme")
    }
    if (typeof window !== "undefined") {
      localStorage.setItem("theme", theme)
    }
  }, [theme])

  useEffect(() => {
    const handleScroll = () => {
      const container = document.querySelector("#containerElement")
      if (container) {
        setSticky(container.scrollTop > 100)
      }
    }

    const container = document.querySelector("#containerElement")
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
    }
  }, [])

  const toggleMenu = () => setHidden(!isHidden)
  const toggleTheme = () => setTheme(prev => (prev === "dark" ? "light" : "dark"))

  const handleHomeClick = () => {
    setHidden(true)
    const container = document.querySelector("#containerElement")
    if (container) {
      container.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      })
    }
  }

  return (
    <header
      ref={ref}
      className={`${styles.header} ${isSticky ? styles.sticky : ""} ${
        !isHidden ? styles.menuOpen : ""
      }`}
    >
      <div className={styles.navContainer}>
        <div className={styles.logo} onClick={handleHomeClick}>
          Abhay<span className={styles.accent}>.</span>
        </div>

        <nav className={`${styles.navLinks} ${!isHidden ? styles.show : ""}`}>
          <a onClick={handleHomeClick} className={styles.link}>
            Home
          </a>
          <ScrollLink
            to={Constants.secondInsideContainer}
            text="Experience"
            onClick={() => setHidden(true)}
          />
          <ScrollLink
            to={Constants.thirdInsideContainer}
            text="Projects"
            onClick={() => setHidden(true)}
          />
          <ScrollLink
            to={Constants.fourthInsideContainer}
            text="Skills"
            onClick={() => setHidden(true)}
          />
          <ScrollLink
            to={Constants.fivthInsideContainer}
            text="About"
            onClick={() => setHidden(true)}
          />
          <ScrollLink
            to={Constants.sixthInsideContainer}
            text="Contact"
            onClick={() => setHidden(true)}
          />
        </nav>

        <div className={styles.navActions}>
          <button onClick={toggleTheme} className={styles.themeToggle} aria-label="Toggle Theme">
            {theme === "dark" ? <FiSun /> : <FiMoon />}
          </button>

          <button className={styles.hamburger} onClick={toggleMenu} aria-label="Toggle Navigation">
            <GiHamburgerMenu />
          </button>
        </div>
      </div>
    </header>
  )
}

function ScrollLink({ to, text, onClick }) {
  return (
    <ReactScrollLink
      to={to}
      containerId={Constants.containerElement}
      className={styles.link}
      activeClass={styles.active}
      spy={true}
      smooth={true}
      hashSpy={true}
      offset={-80}
      isDynamic={true}
      onClick={onClick}
    >
      {text}
    </ReactScrollLink>
  )
}

ScrollLink.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
}

export default Header
